import { inject } from '@angular/core';
import { Routes, ɵEmptyOutletComponent } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { LocaleService } from 'src/app/core/locale/locale.service';
import { CatalogResolver } from './core/catalog.resolver';
import { LanguageGuard } from './language.guard';

export enum RouteId {
  OrderStatus = 'OrderStatus',
  Cart = 'Cart',
  Checkout = 'Checkout',
  OrderSuccess = 'OrderSuccess',
  Login = 'Login',
  TermsAndConditions = 'TermsAndConditions',
  PwReset = 'PwReset',
  ObjectChoice = 'ObjectChoice',
  GiftCard = 'GiftCard'
}

export const routes: Routes = [
  {
    path: 'Order/:OrderIdStatus',
    loadComponent: () => import('./order-status/order-status.component').then(m => m.OrderStatusComponent),
    data: {
      titleTranslationKey: _('ORDER_STATUS.PAGE_TITLE'),
      routeId: RouteId.OrderStatus
    },
    resolve: [CatalogResolver]
  },
  {
    path: 'Infoscreen/m/:key',
    loadComponent: () => import('./infoscreen/infoscreen.component').then(m => m.InfoscreenComponent)
  },
  {
    path: ':catalog/Admin',
    resolve: [CatalogResolver],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: ':catalog/:lang',
    resolve: [CatalogResolver],
    canActivate: [LanguageGuard],
    children: [
      {
        path: 'cart',
        loadComponent: () => import('./cart/cart.component').then(c => c.CartComponent),
        data: {
          titleTranslationKey: _('NAVIGATION.CART'),
          routeId: RouteId.Cart
        }
      },
      {
        path: 'checkout',
        loadComponent: () => import('./checkout/checkout.component').then(c => c.CheckoutComponent),
        data: {
          titleTranslationKey: _('CHECKOUT.PAGE_TITLE'),
          routeId: RouteId.Checkout
        }
      },
      {
        path: 'order-success/:OrderIdSuccess',
        loadComponent: () => import('./checkout/checkout-success/checkout-success.component').then(c => c.CheckoutSuccessComponent),
        data: {
          titleTranslationKey: _('CHECKOUT.SUCCESS_HEADING'),
          routeId: RouteId.OrderSuccess
        }
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () => import('./terms-and-conditions/terms-and-conditions.component').then(c => c.TermsAndConditionsComponent),
        data: {
          titleTranslationKey: _('TERMS_AND_CONDITIONS'),
          routeId: RouteId.TermsAndConditions
        }
      },
      {
        path: 'terms-and-conditions/:entityId',
        loadComponent: () => import('./terms-and-conditions/terms-and-conditions-details/terms-and-conditions-details.component').then(c => c.TermsAndConditionsDetailsComponent),
        data: {
          titleTranslationKey: _('TERMS_AND_CONDITIONS'),
          routeId: RouteId.TermsAndConditions
        }
      },
      {
        path: 'login',
        loadComponent: () => import('./user/login-route/login-route.component').then(c => c.LoginRouteComponent),
        data: {
          titleTranslationKey: _('LOGIN.LOGIN'),
          routeId: RouteId.Login
        }
      },
      {
        path: 'pw-reset',
        loadComponent: () => import('./user/login-route/login-route.component').then(c => c.LoginRouteComponent),
        data: {
          titleTranslationKey: _('PW.RESET_PW'),
          routeId: RouteId.PwReset
        }
      },
      {
        path: 'coupon',
        loadComponent: () => import('./gift-card/gift-card-insight/gift-card-insight.component').then(c => c.GiftCardInsightComponent),
        data: { titleTranslationKey: _('GIFT_CARD.GIFT_CARD'), routeId: RouteId.GiftCard },
        children: [
          {
            path: ':couponCode',
            component: ɵEmptyOutletComponent,
            data: { titleTranslationKey: _('GIFT_CARD.GIFT_CARD'), routeId: RouteId.GiftCard }
          }
        ]
      },
      {
        path: '**',
        loadComponent: () => {
          if (document.location.pathname.startsWith('/GKGBE'))
            return import('./customizations/ref-bern/object-choice/object-choice-refbern.component').then(m => m.ObjectChoiceRefBernComponent)
          else
            return import('./object-choice/object-choice/object-choice.component').then(m => m.ObjectChoiceComponent)
        },
        data: {
          titleTranslationKey: _('NAVIGATION.CHOICES_PAGE_TITLE'),
          routeId: RouteId.ObjectChoice
        }
      }
    ],
  },
  // when the language is missing in the route: redirect to the current language
  {
    path: ':catalog',
    resolve: [CatalogResolver],
    redirectTo: () => ':catalog/' + inject(LocaleService).currentLang()
  },
]
